<div style="display: block;">
    <h6>Current State</h6>
</div>